import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from "material-react-table";

import { useMemo } from "react";
import { RtsDetails } from "../../../app/models/responseModels/DdRouteProgressResponse";
import {
  RTS_DETAIL_COLUMN_NAME,
  RTS_DETAIL_HEADER_NAME,
} from "../RouteProgressConstants";
import { getDefaultMRTOptions } from "../../dedicatedDelivery/DefaultMrtOptions";

interface RtsDetailsModalProps {
  data: RtsDetails[];
}
const defaultMRTOptions = getDefaultMRTOptions<RtsDetails>();
const RtsDetailsModal: React.FC<RtsDetailsModalProps> = ({ data }) => {
  const columns = useMemo<MRT_ColumnDef<RtsDetails>[]>(
    () => [
      {
        accessorKey: RTS_DETAIL_COLUMN_NAME.REASON,
        header: RTS_DETAIL_HEADER_NAME.REASON,
        size: 10,
      },
      {
        accessorKey: RTS_DETAIL_COLUMN_NAME.TOTAL_PACKAGES,
        header: RTS_DETAIL_HEADER_NAME.TOTAL_PACKAGES,
        size: 10,
      },
      {
        accessorKey: RTS_DETAIL_COLUMN_NAME.TIMESTAMP, //normal accessorKey
        header: RTS_DETAIL_HEADER_NAME.TIMESTAMP,
        size: 10,
        Cell: ({ cell, row }) =>
          row?.original?.timestamp
            ? new Date(cell.getValue<string>()).toLocaleString("en-US", {
                hourCycle: "h12",
              })
            : "",
      },
    ],
    []
  );
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    enableSorting: true,
    data: data,
    enableFullScreenToggle: false,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {
        id: false,
      },
    },
    state: {
      showProgressBars: false,
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {},
      ...defaultMRTOptions.muiTableBodyRowProps,
      sx: {
        cursor: "pointer",
      },
    }),
  });
  return <MaterialReactTable table={table} />;
};
export default RtsDetailsModal;
